<div *ngIf="!loading; else showSpinner">
  <div class="container-fluid">
    <h1 *ngIf="!loadingChildren" class="mBottom2">
      {{ "ULTIMAS_MEDICIONES.TITLE" | translate }}
    </h1>
    <div *ngIf="!loadingChildren" class="row">
      <div class="col-md-12 col-lg-12">
        <mat-form-field class="filtro-tabla">
          <mat-label>{{ "ULTIMAS_MEDICIONES.FILTER" | translate }}</mat-label>
          <input
            matInput
            (keyup)="applyFilter()"
            [formControl]="filter"
            placeholder="Buscar dispositivo..."
          />
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="container-fluid tableStyle">
        <ng-container>
          <!-- contenido -->
          <div
            class="row"
            *ngIf="filteredEntities$ | async; let filteredEntities"
          >
            <div
              *ngFor="let item of filteredEntities"
              class="col-sm-12 col-md-6 col-lg-6"
            >
              <app-device-datos
                [lastDataDeviceMapped]="item"
                [deviceId]="item.uuid"
                [isModal]="false"
                [loading]="loadingChildren"
                [selectedLanguage]="selectedLanguage"
              >
              </app-device-datos>
              <br />
              <br />
            </div>
            <div *ngIf="!hasChildren(filteredEntities)">
              <div class="container mtop5">
                <div class="text-center">
                  <h4>{{ "WARNING_MESSAGES.NO_DEVICES" | translate }}</h4>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
<ng-template #showSpinner>
  <app-loading [loadingText]="loadingText"></app-loading>
</ng-template>
